
// Responsible for managing the list of active agents
import { useState } from "react";

export function useActiveAgents() {
  const [activeAgents, setActiveAgents] = useState<string[]>([]);
  return { activeAgents, setActiveAgents };
}
